const DEFAULT_BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL || "";
const VERIFICATION_BACKEND_URL =
  process.env.NEXT_PUBLIC_VERIFICATION_BACKEND_URL || "";

const LOCALHOST_NAMES = new Set(["localhost", "127.0.0.1"]);

function isLocalhostAccess(hostname: string): boolean {
  return LOCALHOST_NAMES.has(hostname) || hostname.endsWith(".localhost");
}

export function resolveBackendUrl(): string {
  if (
    typeof window === "undefined" ||
    !VERIFICATION_BACKEND_URL ||
    !isLocalhostAccess(window.location.hostname)
  ) {
    return DEFAULT_BACKEND_URL;
  }

  return VERIFICATION_BACKEND_URL;
}
